import { FC } from "react";

import { StepManualMeasurements } from "./StepManualMeasurements";
import StepMeasurementListeners from "./StepMeasurementListeners";
import { ListenerTag } from "@/features/procedures/model/procedure/ListenerTag";
import { ProcedureNodeStep } from "@/features/procedures/model/types/checklist";
import { CheckpointType } from "@/features/procedures/model/types/manualChecklist";

export interface StepMeasurementsProps {
	activeSchemeId: number | undefined;
	autoMode: boolean;
	listenerTags: Array<ListenerTag>;
	showMeasurements: boolean;
	step: ProcedureNodeStep;
	setShowMeasurements: (show: boolean) => void;
	isActiveStep: boolean;
}

export const StepMeasurements: FC<StepMeasurementsProps> = (props) => {
	if (props.step?.CheckpointType === CheckpointType.ManualMeasurement) {
		return <StepManualMeasurements {...props} />;
	}

	return <StepMeasurementListeners {...props} />;
};
